import React, { Component } from 'react';
import { inject, observer} from 'mobx-react';
import PortalLink from '../../portal/portalLink';

@inject('translationsStore', 'configurationsStore', 'authStore', 'authenticationProvidersStore') @observer
export default class LinksContainer extends Component {

    handleAccountChange = (e) => {
        const { loginSteps } = this.props.authStore;

        this.props.authStore.setTenant('');
        window.localStorage.removeItem('authStoreTenant');
        this.props.authenticationProvidersStore.isIpAuthorized = undefined;
        this.props.authStore.setLoginStep(loginSteps.tenantForm);
    }

    render() {
        
        const { isMultitenancyMode, registrationLink, displayForgotPasswordLink} = this.props.configurationsStore;
        
        let createAccountLink = !isMultitenancyMode && registrationLink? 
                                <a href={registrationLink} target="_blank">{'Create account'}</a> :
            null;

        
        let forgotPasswordLink = this.props.authenticationProvidersStore.isIpAuthorized && this.props.displayForgotPasswordLink ? <PortalLink
                      url='/forgotpassword' 
                      text={this.props.translationsStore.translate('FORGOT_PASSWORD_LINK')}
                      dataCy='forgot-password-link'
                    /> : null;
        
        let changeAccountLink = isMultitenancyMode ?
            <a onClick={this.handleAccountChange} data-cy='change-account-link'>
                        {this.props.translationsStore.translate('CHANGE_ACCOUNT')} 
                                </a> :
                                null;

        return(
            <div className={isMultitenancyMode ? 'login-bottom-links_mtac' : 'login-bottom-links_stac'}>
                {!this.props.hideLoginLinks && changeAccountLink}
                {!this.props.hideLoginLinks && createAccountLink}
                {!this.props.hideLoginLinks && forgotPasswordLink}
            </div>
        );

    }
}